/**
 * Dashboard-defined MappingRule[] (remote config) applied on the delegated
 * click in clicks.ts — element/URL/text match → named event, no site code.
 * Ships in the lazy side chunk with clicks.ts.
 */
import { visibleText } from './util';
import type { XApi } from './xapi';

/** Plain substring, or regex when wrapped in slashes (`/checkout\/\d+/`). */
export function urlOk(p: string): boolean {
	const path = location.pathname;
	if (p.length > 1 && p[0] == '/' && p.endsWith('/')) {
		try {
			return new RegExp(p.slice(1, -1)).test(path);
		} catch {
			return false;
		}
	}
	return path.indexOf(p) > -1;
}

export function applyMappings(t: Element, x: XApi): void {
	for (const r of x.g()) {
		try {
			const m = r.selector ? t.closest(r.selector) : t;
			if (
				m &&
				(!r.urlPattern || urlOk(r.urlPattern)) &&
				// operators author rules against what they SEE — an svg tooltip
				// <title> inside the button must not make textEquals unmatchable
				(!r.textEquals || visibleText(m).trim().toLowerCase() == r.textEquals.trim().toLowerCase())
			)
				x.q(r.eventName, {
					mapped: true,
					mappingId: r.id,
					...(r.funnel && { funnel: r.funnel }),
					...(r.step && { step: r.step }),
				});
		} catch {}
	}
}
